// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : payload value passing method change
// MODIFIED DATE : 17-09-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import {
	fetchFutureDemandReportSuccess,
	fetchFutureDemandReportFailure,
	fetchFutureDemandReportResponseResetChanged,
} from './future-demand-report.action';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import futureDemandReportTypes from './future-demand-report.types';
import { getFutureDemandReportDetails } from './future-demand-report.service';

/** *********************  START FETCH FUTURE DEMAND DETAILS  ******************** */
export function* fetchFutureDemandReportReportDetails({ payload }: any) {
	try {
		const key = 'FutureDemandDetailsKey';
		const {
			companyID,
			databaseName,
			branchID,
			fromDate,
			funderID,
			isPersonalLoan,
			centerID,
			toDate,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			BranchID: branchID,
			FromDate: fromDate,
			FunderID: funderID,
			IsPersonalLoan: isPersonalLoan,
			LocationID: centerID,
			ToDate: toDate,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getFutureDemandReportDetails, encodeData);
		if (responseData.data.statusCode === '101') {
			yield put(fetchFutureDemandReportFailure(responseData.data));
		} else {
			yield put(fetchFutureDemandReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchFutureDemandReportFailure(error));
	}
}

export function* resetFetchFutureDemandReportResponse() {
	yield put(fetchFutureDemandReportResponseResetChanged());
}

export function* onFetchFutureDemandReportDetails() {
	yield takeLatest(
		futureDemandReportTypes.FETCH_FUTURE_DEMAND_REPORT_START,
		fetchFutureDemandReportReportDetails,
	);
}

export function* onFetchFutureDemandReportResponseReset() {
	yield takeLatest(
		futureDemandReportTypes.FETCH_FUTURE_DEMAND_REPORT_RESPONSE_RESET_START,
		resetFetchFutureDemandReportResponse,
	);
}
/** *********************  END FETCH FUTURE DEMAND DETAILS ******************** */

export function* futureDemandReportSaga() {
	yield all([
		call(onFetchFutureDemandReportDetails),
		call(onFetchFutureDemandReportResponseReset),
	]);
}
